module.exports = __webpack_public_path__ + "img/photoshoots.b9168c3c.svg";